import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".PriceInput-module_leftElementWrapper__OsCf5 input {\n  padding-left: 3.5rem;\n  font-weight: 500;\n}\n\n.PriceInput-module_leftElement__6af0e {\n  height: calc(100% - 2px);\n  margin-top: 1px;\n  border-right: 1px solid #dee0e2;\n  padding-right: 16px;\n  padding-left: 16px;\n  font-weight: 500;\n}";
var styles = {"leftElementWrapper":"PriceInput-module_leftElementWrapper__OsCf5","leftElement":"PriceInput-module_leftElement__6af0e"};
styleInject(css_248z);

export { styles as default };
